export default __webpack_public_path__ + "fonts/workflow_bg.5ed3355861a1d7d6c05c33292f25f8f5.png";